/* eslint-disable */
import React from 'react'
import {message} from 'antd'
import http from '../../Component/Interceptor/Interseptor'
import {Link} from 'react-router-dom'
import cookie from 'react-cookies'
import CRM from '../BaseComponent/CRM'

class AddMedia extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      error: ''
    }
  }
  componentDidMount() {}

  addMedia() {
    var name = document.getElementById('name').value
    var enabled = document.getElementById('enabled').value
    var nameError = false
    var enableError = false
    var formError = false
    if (name == '') {
      formError = true
      nameError = true
      message.error('نام رسانه تماس وارد شود')
    } else {
      if (!nameError) {
        this.setState({
          error: ''
        })
      }
    }

    if (enabled == '') {
      formError = true
      enableError = true
      message.error('وضعیت را مشخص کنید')
    } else {
      if (!enableError) {
        this.setState({
          error: ''
        })
      }
    }
    if (!formError) {
      let data = {
        name,
        enabled
      }

      http
        .post(`${CRM.CRM_CONTACT_MEDIA_ADD}`, data)
        .then((response) => {
          if (response.data.error == null) {
            message.success('رسانه تماس جدید اضافه شد')
            setInterval(() => {
              window.location.assign('/reportMedia')
            }, 2000)
          } else {
            message.error('خطای ' + response.data.errorCode + ' : ' + response.data.description)
          }
        })
        .catch((error) => {
          alert(JSON.stringify(error))
        })
    }
  }

  submit(e) {
    e.preventDefault()
  }
  render() {
    return (
      <div className={'rtl'}>
        {/*<AdminMenu/>*/}
        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>اطلاعات پایه</li>
            <li>ارتباط با مشتری</li>
            <li>
              <Link to={'/reportMedia'}>رسانه های تماس</Link>
            </li>
            <li>افزودن رسانه تماس</li>
          </ul>
          <form className="verticalForm" onSubmit={this.submit.bind(this)}>
            <div className="headerVertical">
              <p>ثبت رسانه تماس</p>
            </div>
            <div className="formComponent">
              <label>
                عنوان <span className="requireFiled">*</span>
              </label>
              <input type="text" id="name" className="form-control" />

              <label>
                وضعیت <span className="requireFiled">*</span>
              </label>
              <select className="form-control" name="enabled" id="enabled">
                <option value="">------</option>
                <option value={1}>فعال</option>
                <option value={0}>غیر فعال</option>
              </select>

              <button className="btn btn-info btn-block" onClick={this.addMedia.bind(this)}>
                ثبت رسانه تماس جدید
              </button>
            </div>
          </form>
        </div>
      </div>
    )
  }
}

export default AddMedia
